import React, { useCallback, useState } from "react";
import {
  TextInput,
  Button,
  Box,
  useMantineTheme,
  Paper,
  Flex,
  Autocomplete,
} from "@mantine/core";

import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { geocodeByAddress } from "react-google-places-autocomplete";
import { notifications } from "@mantine/notifications";
import { logEvent } from "../logEvent";
import { useAppContext } from "../AppContext";

export default function SearchBlockPlace(props: any) {
  const {
    selectedPlace,
    setSelectedPlace,
    map,
    setZoom,
    closeWelcomeModal,
    place,
    selectedLocations,
    setBlockedLocations,
    blockedLocations,
    blockedPlacesInputRef,
  }: any = useAppContext();
  const { mt, blockedLocationRadius, setBlockedLocationRadius } = props;

  const [blockedPlace, setBlockedPlace] = useState("");
  const handlePlacesInput = useCallback(async () => {
    logEvent("event", {
      target: "Search blocked place form",
    });
    let geoCode;
    try {
      geoCode = await geocodeByAddress(blockedPlace);
    } catch (err) {
      return notifications.show({
        message: "Can't find that location, check your input and try again.",
        color: "red",
      });
    }
    const latLng: any = await getLatLng(geoCode[0]);
    latLng["radius"] = blockedLocationRadius;
    setBlockedLocations([...blockedLocations, latLng]);
    setBlockedPlace("");
    setBlockedLocationRadius(1);
  }, [blockedPlace, setBlockedLocations, blockedLocationRadius]);
  return (
    <Flex direction="row" mt={mt}>
      <TextInput
        ref={blockedPlacesInputRef}
        value={blockedPlace}
        onChange={(e) => {
          setBlockedPlace(e.currentTarget.value);
        }}
        onKeyDown={async (event) => {
          if (event.key === "Enter") {
            handlePlacesInput();
          }
        }}
        placeholder="555 N Happy Ln, Denver"
        mr="md"
        flex={1}
      />
      <Button
        onClick={() => {
          handlePlacesInput();
        }}
      >
        Search location to block
      </Button>
    </Flex>
  );
}
